/**
 *  Custom swiper pagination fof MUAC.
 *
 *  To be used as customRender function in swiper instance.
 */

const SIGHT = 2;
const BULLET_SIZE = 6;

export function pagination (swiper, current, total)  {
  let output = '';
  const index = current - 1;
  const maxIndex = total - 1;
  const window = Math.min(2 * SIGHT + 1, total);
  const lastInWindow = Math.min(maxIndex, Math.max(window, current + SIGHT) - 1);
  const firstInWindow = Math.max(0, Math.min(total + 1 - window, current - SIGHT) - 1);

  const currentNodes = swiper.pagination.el.children;
  const update = currentNodes.length === total;

  for (let i = 0; i < total; i += 1) {
    const classes = ['swiper-pagination-bullet'];

    if (index === i) {
      classes.push('swiper-pagination-bullet-active');
    }

    if (i === firstInWindow && i > 0) {
      classes.push('swiper-pagination-bullet-tiny');
    }

    if (i === lastInWindow && i < maxIndex) {
      classes.push('swiper-pagination-bullet-tiny');
    }

    if (i < firstInWindow && i > 0) {
      classes.push('swiper-pagination-bullet-off');
    }

    if (i > lastInWindow && i < maxIndex) {
      classes.push('swiper-pagination-bullet-off');
    }

    if (update) {
      currentNodes[i].setAttribute('class', classes.join(' '));
    } else {
      output += `<span class="${classes.join(' ')}"></span>`;
    }
  }

  /* These values are based on the specific styling */
  swiper.pagination.el.style.left = `calc(${firstInWindow * -1.5}rem - ${BULLET_SIZE * firstInWindow}px)`;

  if (!update) {
    return output;
  }
}



// WEBPACK FOOTER //
// ./website/assets/scripts/modules/pagination.js